import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getAppStoreUrl(): string {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return import.meta.env.VITE_ANDROID_APP_URL;
  return import.meta.env.VITE_APPLE_APP_URL;
}
